import {Component, Input } from '@angular/core';
import {CFASTLINKMAPFARLINK } from "../fastlinkstruct";

@Component({
  selector: 'app-fast-link-far-link',
  templateUrl: './fast-link-far-link.component.html',
  styleUrls: ['./fast-link-far-link.component.css']
})
export class FastLinkFarLinkComponent   {
  @Input() farLink: CFASTLINKMAPFARLINK | undefined;

  constructor() { }



}
